import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateContentLibraryFolderMutation,
  CreateContentLibraryFolderMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { customerDocumentsKey } from "./useCustomerDocuments";

const CREATE_CONTENT_LIBRARY_FOLDER_QUERY = graphql(`
  mutation createContentLibraryFolder($request: CreateFolderRequest!) {
    createContentLibraryFolder(CreateFolderRequest: $request) {
      docId
      resourceId
      name
      documentType
      uiPath
    }
  }
`);

export function useCreateContentLibraryFolder(
  options?: UseMutationOptions<
    CreateContentLibraryFolderMutation,
    unknown,
    CreateContentLibraryFolderMutationVariables,
    unknown
  >,
) {
  const client = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(CREATE_CONTENT_LIBRARY_FOLDER_QUERY, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
      // Update query cache to reflect the successful processing of the document

      const { documentType, resourceId, uiPath } = data.createContentLibraryFolder;

      await client.invalidateQueries({
        queryKey: customerDocumentsKey({ documentType, resourceId, uiPath }),
        exact: false, // Allow matching without pagination;
      });
    },
  });

  return { data: data?.createContentLibraryFolder, ...rest };
}
